export default __webpack_public_path__ + "static/media/TVR.4ded0a27.png";